import { render, staticRenderFns } from "./SavingPlanList.vue?vue&type=template&id=807b66d0&"
import script from "./SavingPlanList.vue?vue&type=script&lang=js&"
export * from "./SavingPlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports